// Central block icon set.
//
// One place for every block-type icon so the whole editor uses a single,
// consistent visual language: 24x24 viewBox, geometric shapes, solid fill
// via `currentColor` (same style as the editor UI icons).
//
// Add new block types HERE with an icon drawn in the same style —
// never reuse an existing type's icon for a different type.

const wrap = (path) =>
  `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="currentColor"><path fill-rule="evenodd" d="${path}"/></svg>`;

const paths = {
  // Hero-like full-width slider: frame + centered slide + nav dots
  slider:
    "M2 5h20v14H2V5zm2 2v10h16V7H4zm4 2h8v5H8V9zM5 10.5h1.5v2H5v-2zm12.5 0H19v2h-1.5v-2zM10 16h1.5v1.5H10V16zm2.5 0H14v1.5h-1.5V16z",
  // Two stacked boxes + tall featured column
  "top-products":
    "M3 3h8v8H3V3zm2 2v4h4V5H5zm8-2h8v18h-8V3zm2 2v14h4V5h-4zM3 13h8v8H3v-8zm2 2v4h4v-4H5z",
  // Product list: 2x2 grid
  "featured-products":
    "M3 3h8v8H3V3zm2 2v4h4V5H5zm8-2h8v8h-8V3zm2 2v4h4V5h-4zM3 13h8v8H3v-8zm2 2v4h4v-4H5zm8-2h8v8h-8v-8zm2 2v4h4v-4h-4z",
  // Center card with side rails (carousel of products)
  "product-slider":
    "M2 7h3v10H2V7zm17 0h3v10h-3V7zM7 5h10v14H7V5zm2 2v10h6V7H9z",
  // Text lines
  text: "M3 5h18v2H3V5zm0 4h12v2H3V9zm0 4h18v2H3v-2zm0 4h10v2H3v-2z",
  // Storefront: awning + posts + door
  store:
    "M2 4h20v6h-2v10h-2V10H6v10H4V10H2V4zm2 2v2h16V6H4zm5 8h6v6H9v-6zm2 2v2h2v-2h-2z",
  // Image panel + text lines
  "image-with-text":
    "M2 4h10v16H2V4zm2 2v12h6V6H4zm10 1h8v2h-8V7zm0 4h8v2h-8v-2zm0 4h5v2h-5v-2z",
  // Code brackets
  html: "M9.4 16.6L4.8 12l4.6-4.6L8 6l-6 6 6 6 1.4-1.4zm5.2 0l4.6-4.6-4.6-4.6L16 6l6 6-6 6-1.4-1.4z",
  // Single picture: frame + sun + mountains
  pictures:
    "M4 5h16v14H4V5zm2 2v10h12V7H6zm3 3a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm-2 5l3.5-4.5 2.5 3 1.5-2 3.5 3.5H7z",
  // Multiple pictures: stacked frames + mountains
  images:
    "M6 2h16v16h-2V4H6V2zM2 6h16v16H2V6zm2 2v12h12V8H4zm3 10l2.5-3 2 2.5L13 13l3 5H7z",
  // Big cards: front card + peeking next card
  "big-category-card": "M2 5h13v14H2V5zm2 2v10h9V7H4zm13 0h5v2h-3v8h3v2h-5V7z",
  // Row of small cards + nav dots
  "category-slider":
    "M2 5h5v10H2V5zm7 0h6v10H9V5zm8 0h5v10h-5V5zm-6 2v6h2V7h-2zM10 18h1.5v2H10v-2zm3 0h1.5v2H13v-2z",
  // Category boxes: 3 boxes + circle
  "category-box":
    "M3 3h8v8H3V3zm2 2v4h4V5H5zm8-2h8v8h-8V3zm2 2v4h4V5h-4zM3 13h8v8H3v-8zm2 2v4h4v-4H5zm8 2a4 4 0 1 1 8 0 4 4 0 0 1-8 0zm4-2a2 2 0 1 0 0 4 2 2 0 0 0 0-4z",
  // Toggle switch
  "content-toggle":
    "M8 5h8a7 7 0 0 1 0 14H8A7 7 0 0 1 8 5zm0 2a5 5 0 0 0 0 10h8a5 5 0 0 0 0-10H8zm0 8a3 3 0 1 1 0-6 3 3 0 0 1 0 6z",
  // Video: frame + play triangle
  video: "M2 4h20v16H2V4zm2 2v12h16V6H4zm6 2l6 4-6 4V8z",
  // Shuffle arrows
  "product-mix":
    "M2 6h5l10 12h5v2h-6L6 8H2V6zm20 0v2h-5l-2.7 3.24-1.3-1.56L15 6h7zM9.99 14.32l1.3 1.56L8 20H2v-2h5l2.99-3.68z",
  // Funnel
  filter:
    "M21 4v2h-1l-5 7.5V22H9v-8.5L4 6H3V4h18zM6.4 6L11 12.9V20h2v-7.1L17.6 6H6.4z",
  // Page dots with active underline
  pagination:
    "M3 11h4v2H3v-2zm7 0h4v2h-4v-2zm7 0h4v2h-4v-2zm-7 4h4v1.5h-4V15z",
  // Plain menu lines
  menu: "M3 4h18v2H3V4zm0 7h18v2H3v-2zm0 7h18v2H3v-2z",
  // Menu inside a frame
  "hamburger-menu":
    "M2 4h20v16H2V4zm2 2v12h16V6H4zm3 2h10v1.5H7V8zm0 3.25h10v1.5H7v-1.5zm0 3.25h10V16H7v-1.5z",
  // Star
  "social-reviews":
    "M12 2l2.9 6.26 6.6.78-4.88 4.51 1.3 6.51L12 16.77l-5.92 3.29 1.3-6.51L2.5 9.04l6.6-.78L12 2z",
  // Share nodes
  "featured-posts":
    "M13.12 17.023l-4.199-2.29a4 4 0 1 1 0-5.465l4.2-2.29a4 4 0 1 1 .959 1.755l-4.2 2.29a4.008 4.008 0 0 1 0 1.954l4.199 2.29a4 4 0 1 1-.959 1.755zM6 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4zm11-6a2 2 0 1 0 0-4 2 2 0 0 0 0 4zm0 12a2 2 0 1 0 0-4 2 2 0 0 0 0 4z",
  // Fallback: empty frame
  _default: "M2 4h20v16H2V4zm2 2v12h16V6H4z",
};

let duplicateTemplateIcons = new Set();

function normalizeIcon(icon) {
  return typeof icon === "string" ? icon.replace(/\s+/g, "") : "";
}

// Call with the template's blocks.json map after loading it: icons shared
// by several block types are remembered so blockIcon() can replace them —
// every type must stay visually distinguishable.
export function registerTemplateIcons(blocksMap) {
  const seen = new Set();
  duplicateTemplateIcons = new Set();
  for (const key in blocksMap ?? {}) {
    const icon = normalizeIcon(blocksMap[key]?.icon);
    if (!icon) {
      continue;
    }
    if (seen.has(icon)) {
      duplicateTemplateIcons.add(icon);
    }
    seen.add(icon);
  }
}

export function blockIcon(typeName, templateIcon = null) {
  // The selected template's blocks.json is the source of truth: when it
  // ships a UNIQUE icon, always use it. Icons the template reuses across
  // types fall back to the distinct built-in set, as do missing ones.
  const normalized = normalizeIcon(templateIcon);
  if (normalized && !duplicateTemplateIcons.has(normalized)) {
    return templateIcon;
  }
  if (paths[typeName]) {
    return wrap(paths[typeName]);
  }
  if (normalized) {
    return templateIcon;
  }
  return wrap(paths._default);
}
